/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_IssuesInputs */

const cs_import_progress_issues = /** @type {(inputs: Import_Progress_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upozornění`)
};

const en_import_progress_issues = /** @type {(inputs: Import_Progress_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues`)
};

/**
* | output |
* | --- |
* | "Issues" |
*
* @param {Import_Progress_IssuesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_issues = /** @type {((inputs?: Import_Progress_IssuesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_IssuesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_issues(inputs)
	return cs_import_progress_issues(inputs)
});